<div class="ai-chat-panel">
    <uassist-chat
        #widget
        class="uassist-chat-widget"
        [attr.api-url]="config.apiUrl"
        [attr.tenant]="config.tenant"
        [attr.agent-name]="config.agentName"
        [attr.title]="title"
        [attr.placeholder]="placeholder"
        [attr.empty-state-subtitle]="emptyStateSubtitle"
        [attr.theme]="theme"
        borderless="true"
        header="none"
        response-mode="progress"
        height="100%"
        width="100%"
        [attr.accent-color]="config.accentColor"
        [attr.user-accent-color]="config.userBubbleColor"
        [attr.send-button-color]="config.accentColor"
        [attr.background-color]="config.backgroundColor"
        enable-feedback="true"
        show-session-sidebar="true"
        allow-inject="true">
    </uassist-chat>
</div>
